// eslint-disable-next-line import/prefer-default-export
export const getValidation = (state) => state.validation;
